<template>
  <div class="horizon-container">
    <div id="moveLeft" class="h-100 flex-column bg-ff" style="width: 200px">
      <div class="left-top">
        <div class="flex-1 font-16-30313a">款项分类</div>
      </div>
      <div class="flex-1 h-0">
        <cate-menu :not-operate="true" :menu-data="classifyList" @on-choose="onChooseMenu" :choose-id="chooseMenuId"></cate-menu>
      </div>
    </div>
    <move-horizon></move-horizon>
    <outstanding-order v-if="chooseMenuId === 1" :supplier="supplier" :option-list="optionList" :current-classify="currentClassify"></outstanding-order>
    <material-order v-if="chooseMenuId === 2" :supplier="supplier" :option-list="optionList" :current-classify="currentClassify"></material-order>
    <bad-order v-if="chooseMenuId === 3" :supplier="supplier" :option-list="optionList" :current-classify="currentClassify"></bad-order>
  </div>
</template>
<script>
import Pagination from '../../components/Pagination'
import MoveHorizon from '../../components/MoveHorizon'
import MoveVertical from '../../components/MoveVertical'
import CateMenu from '../../components/CateMenu'
import ErpTable from '../../components/ErpTable'
import OutstandingOrder from './comp/OutstandingOrder'
import MaterialOrder from './comp/MaterialOrder'
import BadOrder from './comp/BadOrder'
export default {
  name: 'purchaseMaterialPayment',
  components: {Pagination, MoveHorizon, CateMenu, ErpTable, MoveVertical, OutstandingOrder, BadOrder, MaterialOrder},
  data () {
    return {
      classifyList: [
        {
          id: 1,
          name: '未清材料单',
          tab: [{
            name: '未清材料单'
          }],
          btnList: [{
            name: '生成材料付款单',
            icon: '/static/images/shangmenyubao.png',
            iconActive: '/static/images/shangmenyubao-bai.png'
          }, {
            name: '生成坏账核销单',
            icon: '/static/images/zuofei.png',
            iconActive: '/static/images/zuofei-bai.png'
          }]
        }, {
          id: 2,
          name: '材料付款单',
          tab: [{
            name: '未记账单据'
          }, {
            name: '已记账单据'
          }],
          btnList: [{
            name: '记账',
            icon: '/static/images/shangmenyubao.png',
            iconActive: '/static/images/shangmenyubao-bai.png'
          }, {
            name: '删除',
            icon: '/static/images/shanchu1.png',
            iconActive: '/static/images/shanchu1-bai.png',
            iconStatus: 1
          }]
        }, {
          id: 3,
          name: '坏账核销单',
          tab: [{
            name: '未记账单据'
          }, {
            name: '已记账单据'
          }],
          btnList: [{
            name: '记账',
            icon: '/static/images/shangmenyubao.png',
            iconActive: '/static/images/shangmenyubao-bai.png'
          }, {
            name: '删除',
            icon: '/static/images/shanchu1.png',
            iconActive: '/static/images/shanchu1-bai.png',
            iconStatus: 1
          }]
        }],
      chooseMenuId: 1,
      currentClassify: {},
      supplier: [
        {
          id: '',
          name: '全部供应商'
        }
      ],
      optionList: []
    }
  },
  created () {
    this.currentClassify = this.classifyList[0]
    this.axios.post('order/queryBusinessList', {companyId: this.$store.state.companyId}).then(res => {
      if (res.data.success) {
        this.supplier = this.supplier.concat(res.data.data)
      }
    })
    this.getAccount()
  },
  mounted () {},
  methods: {
    getAccount () {
      this.axios.post(`${this.$store.state.API_URL_9010}/account/list`, {
        companyId: this.$store.state.companyId
      }).then(res => {
        if (res.data.success) {
          this.optionList = res.data.data
        }
      })
    },
    onChooseMenu (menu) {
      if (this.chooseMenuId !== menu.id) {
        this.chooseMenuId = menu.id
        this.currentClassify = menu
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/financeManage/purchaseMaterialPayment.vue